import { Component } from '@angular/core';


export class SkySearchDemoComponent {
  public displayedItems: any;
  public searchText: string;

  private items: any[] = [
    {
      title: 'Call Robert Hernandez',
      note: 'Robert recently gave a very generous gift. We should call to thank him.'
    },
    {
      title: 'Send invitation to ball',
      note: 'The Spring Ball is coming up soon. Let\'s get those invitations out!'
    },
    {
      title: 'Clean up desk',
      note: 'File and organize papers.'
    },
    {
      title: 'Investigate leads',
      note: 'Check out leads for important charity event funding.'
    },
    {
      title: 'Send thank you note',
      note: 'Send a thank you note to Timothy for his donation.'
    }
  ];

  constructor() {
    this.displayedItems = this.items;
  }

  public searchApplied(searchText: string) {
    let filteredItems = this.items;
    this.searchText = searchText;

    if (searchText) {
      filteredItems = this.items.filter(function (item: any) {
        let property: any;

        for (property in item) {
          if (item.hasOwnProperty(property) && (property === 'title' || property === 'note')) {
            if (item[property].indexOf(searchText) > -1) {
              return true;
            }
          }
        }

        return false;
      });
    }
    this.displayedItems = filteredItems;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-search-demo',
  template: `<sky-toolbar>
  <sky-toolbar-item>
    <button
      class="sky-btn sky-btn-default sky-demo-search-bar-item"
      (click)="searchApplied('Robert')">
      Predefined search text
    </button>
  </sky-toolbar-item>
  <sky-toolbar-item>
    <sky-search
      [searchText]="searchText"
      (searchApply)="searchApplied($event)">
    </sky-search>
  </sky-toolbar-item>
</sky-toolbar>
<div>
  <sky-repeater expandMode="none">
    <sky-repeater-item *ngFor="let item of displayedItems">
      <sky-repeater-item-title>
        {{item.title}}
      </sky-repeater-item-title>
      <sky-repeater-item-content>
        <div>
          {{item.note}}
        </div>
      </sky-repeater-item-content>
    </sky-repeater-item>
  </sky-repeater>
</div>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
